
import { css } from 'styled-components'

const heights = {
    footer: 100
}
const widths = {
    navigation: `250px`
}
const colors = {
    white: '#ffffff',
    black: '#000000',
    blackish: '#2f2b2b',
    gray: '#7e7e7e',
    lightgreen: '#c2fbe5',
    turquoise: '#62b998',
    purple: '#a91667',
    blue: '#2b5171',
    frogi: 'rgba(55, 149, 108, .8)',
    red: '#fe0101',
    yellow: '#fdcc06'
}

const media = {
    desktop: (...args) => css`
    @media (min-width: 980px) {
        ${ css(...args)}
    }`,
    middle: (...args) => css`
    @media (min-width: 980px) and (max-width: 1120px) {
        ${ css(...args)}
    }`
}

export {
    heights,
    widths,
    colors,
    media
}


// WEBPACK FOOTER //
// ./src/styles/vars.js